import React from 'react';
import { Linkedin, Twitter, Github } from 'lucide-react';

const SocialLinks = ({ profile }) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-white">Redes Profesionales</h3>
      <div className="space-y-3">
        <a 
          href={`https://${profile.linkedin}`}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3 text-slate-200 bg-blue-600/20 hover:bg-blue-600/30 p-3 rounded-lg transition-colors"
        >
          <Linkedin size={20} className="text-blue-400 flex-shrink-0" />
          <span className="text-sm truncate">{profile.linkedin}</span>
        </a>
        <a 
          href={`https://twitter.com/${profile.twitter.replace('@', '')}`}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3 text-slate-200 bg-sky-600/20 hover:bg-sky-600/30 p-3 rounded-lg transition-colors"
        >
          <Twitter size={20} className="text-sky-400 flex-shrink-0" />
          <span className="text-sm">{profile.twitter}</span>
        </a>
        <a 
          href={`https://${profile.github}`}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3 text-slate-200 bg-slate-700/50 hover:bg-slate-700/70 p-3 rounded-lg transition-colors"
        >
          <Github size={20} className="text-slate-300 flex-shrink-0" />
          <span className="text-sm truncate">{profile.github}</span>
        </a>
      </div>
    </div>
  );
};

export default SocialLinks;
